import { NgModule } from '@angular/core';

import { FeatherIconDirective } from '@core/directives/core-feather-icons/core-feather-icons';
import { RippleEffectDirective } from '@core/directives/core-ripple-effect/core-ripple-effect.directive';
import { NumberFormatterDirective } from 'app/main/pages/_sommavi/_commons/directives/number-formatter.directive';

@NgModule({
  declarations: [RippleEffectDirective, FeatherIconDirective, NumberFormatterDirective],
  exports: [RippleEffectDirective, FeatherIconDirective, NumberFormatterDirective]
})
export class CoreDirectivesModule {}
